<div class="block justify-items-center">
  <p-scrollpanel #scrollPanel [style]="{ width: '100%', height: '68vh' }">
    <div class="md:px-8 lg:px-16">
      <div class="justify-items-center">
        <img class="block w-full rounded-md" src="/assets/images/placeholder.webp" alt="" draggable="false">
      </div>
      <div class="mt-8 mx-4" [innerHTML]="currentFeedItem.content"></div>
    </div>
  </p-scrollpanel>
</div>
<div class="bg-grey-bg border-t border-grey-300 py-4 mt-4 -mb-5 -mx-5 w-[calc(100%+--spacing(10))]">
  <div class="flex justify-between mx-4">
    <div>
      @if(feedIndex !== 0) {
        <button class="flex items-center gap-2 bg-white border border-grey-400 text-sm text-grey-900 rounded-sm cursor-pointer px-4 py-2" (click)="previous()">
          <i class="pi pi-chevron-left"></i>
          {{ 'whatsNew.previous' | transloco }}
        </button>
      }
    </div>
    <div>
      @if (feedIndex !== allFeedItems.item_count - 1){  
        <button class="flex items-center gap-2 bg-white border border-grey-400 text-sm text-grey-900 rounded-sm cursor-pointer px-4 py-2 self-center" (click)="next()">
          {{ 'whatsNew.next' | transloco }}
          <i class="pi pi-chevron-right"></i>
        </button>
      }
    </div>
  </div>
</div>